import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class AccountCategory  {
    _originalTypeClassName = "zERP.BO.AccountCategory";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
AccountCategory.translate = translateService;
}
this.ChildAccountCategories = [];
this.AccountCategoryID = null;
this.Code = null;
this.Name = null;
this.CategoryLevel = null;
this.HasAccountsCalculated = false;
this.FullName = null;
this.Type = null;
this._key = this.AccountCategoryID = 0; 
}

static translate: TranslateService;
_key: any;
private _AccountCategoryID:any;
get AccountCategoryID(): any {
    return this._AccountCategoryID;
  }
set AccountCategoryID(value: any) {
    this._AccountCategoryID = value;
    this._key = value;
  }
Code:any;
Name:any;
CategoryLevel:any;
HasAccountsCalculated:any;
FullName:any;
Type:any;
ParentAccountCategory:any;
ChildAccountCategories:any;
NEWAccountCategory:any;
Ledger:any;
static setParentAccountCategory = ($this, value) => {
var oldValue = $this.ParentAccountCategory;
$this.ParentAccountCategory = value;
if (value != null) {
if (oldValue != null) {
Domain.AccountCategory.removeChildAccountCategories(oldValue, $this);
}
Domain.AccountCategory.addChildAccountCategories(value, $this);
}
}
static setChildAccountCategories = ($this, items) => {
                if (items == null) items = [];
                if ($this.ChildAccountCategories == null) $this.ChildAccountCategories = [];

                const copyItems = Common.cloneObject(items);

                while ($this.ChildAccountCategories.length > 0) {
                    Domain.AccountCategory.removeChildAccountCategories($this, $this.ChildAccountCategories[0]);
                }

                Domain.AccountCategory.addManyChildAccountCategories($this, copyItems);
            }
static addManyChildAccountCategories = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.AccountCategory.addChildAccountCategories($this, items[i]);
                }
            }
static addChildAccountCategories = ($this, item) => {
                if ($this.ChildAccountCategories == null) $this.ChildAccountCategories = [];
                if (item == null || $this.ChildAccountCategories.indexOf(item) > -1) return;
                $this.ChildAccountCategories.push(item);
if (item.ParentAccountCategory != $this) {
Domain.AccountCategory.setParentAccountCategory(item, $this);
}
}
static addRangeChildAccountCategories = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.AccountCategory.addChildAccountCategories($this, item));
            }
static removeChildAccountCategories = ($this, item) => {
                if ($this == null || $this.ChildAccountCategories == null || $this.ChildAccountCategories.indexOf(item) === -1) return;
                var _index = $this.ChildAccountCategories.indexOf(item);
                $this.ChildAccountCategories.splice(_index, 1);
item.ParentAccountCategory = null;
}
static clearChildAccountCategories = ($this) => { $this.ChildAccountCategories = null; }
static setNEWAccountCategory = ($this, value) => {
var oldValue = $this.NEWAccountCategory;
$this.NEWAccountCategory = value;
if (value != null) {
}
}
static setLedger = ($this, value) => {
var oldValue = $this.Ledger;
$this.Ledger = value;
if (value != null) {
if (oldValue != null) {
Domain.Ledger.removeAccountCategories(oldValue, $this);
}
Domain.Ledger.addAccountCategories(value, $this);
}
}

static GetFullName($this: any): any{return $this?.Code + " - " + $this?.Name;
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.AccountCategoryID == null || $this.AccountCategoryID == 0;
            }


}